import { useEffect } from 'react';

const PROJECT_ID = 'TGE36dZ19XpX1u8v8hSn';
const UNICORN_SCRIPT =
  'https://cdn.jsdelivr.net/gh/hiunicornstudio/unicornstudio.js@v2.1.6/dist/unicornStudio.umd.js';

function ensureBackgroundLayer(id) {
  let layer = document.getElementById(id);
  if (!layer) {
    layer = document.createElement('div');
    layer.id = id;
    document.body.prepend(layer);
  }
  return layer;
}

function loadUnicornScript() {
  return new Promise((resolve, reject) => {
    if (window.UnicornStudio?.init) {
      resolve();
      return;
    }

    const existing = document.querySelector('script[src*="unicornStudio.umd.js"]');
    if (existing) {
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', reject, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = UNICORN_SCRIPT;
    script.onload = () => resolve();
    script.onerror = reject;
    (document.head || document.body).appendChild(script);
  });
}

export default function UnicornSingleton() {
  useEffect(() => {
    ensureBackgroundLayer('unicorn-base');
    ensureBackgroundLayer('unicorn-veil');

    let container = document.getElementById('unicorn-layer');
    if (!container) {
      container = document.createElement('div');
      container.id = 'unicorn-layer';
      Object.assign(container.style, {
        position: 'fixed',
        inset: '0',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: '-1',
        backgroundColor: 'transparent',
        transform: 'translateZ(0)',
        willChange: 'transform',
      });

      container.setAttribute('data-us-project', PROJECT_ID);
      container.setAttribute('data-us-scale', '1');
      container.setAttribute('data-us-dpi', '2');
      container.setAttribute('data-us-fps', '60');

      document.body.prepend(container);
    }

    const init = () => {
      const u = window.UnicornStudio;
      if (!u?.init) return;
      if (!u.isInitialized) {
        u.init().catch((e) => console.error('Unicorn init error', e));
      }
    };

    loadUnicornScript()
      .then(init)
      .catch((e) => console.error('Unicorn script load error', e));

    return () => {};
  }, []);

  return null;
}
